import { api } from './client'
import type {
  DrawingSet,
  PlanIndexRef,
  PlanIndexRefSet,
  PlanTargetBinding,
  PlanTargetBindingSet,
  UpsertPlanIndexRefRequest,
  UUID,
} from '@/types/api'

export const bindingsApi = {
  drawingSet: async (jobId: UUID): Promise<DrawingSet> =>
    (await api.get(`/jobs/${jobId}/drawing-set`)).data,

  refs: async (jobId: UUID): Promise<PlanIndexRefSet> =>
    (await api.get(`/jobs/${jobId}/plan-index-refs`)).data,

  binding: async (jobId: UUID): Promise<PlanTargetBindingSet> =>
    (await api.get(`/jobs/${jobId}/drawing-binding`)).data,

  upsert: async (
    jobId: UUID,
    body: UpsertPlanIndexRefRequest,
  ): Promise<{ ref: PlanIndexRef; binding: PlanTargetBinding }> =>
    (await api.post(`/jobs/${jobId}/plan-index-refs:upsert`, body)).data,

  remove: async (jobId: UUID, refId: UUID): Promise<void> => {
    await api.delete(`/jobs/${jobId}/plan-index-refs/${refId}`)
  },
}
